var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tabs-item"},[_c('router-link',{staticClass:"tab-link text-sm",attrs:{"to":_vm.link}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }